import React from "react";
import { CaseData, CMSData } from "@/cms/models";
import { isLookSystem } from "@/utils/look-gate";
import { LOOK_FIELD_FONT } from "@/utils/theme-fonts";
import { capitalize, formatDate, formatTime, GetFont } from "@/utils/helper";
import { HomepageOpenhouseFraction } from "@/utils/gql/graphql";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface OpenHouseSelectProps {
  errors: string[] | undefined;
  cmsData: CMSData;
  label: string;
  caseData: CaseData;
  selected?: HomepageOpenhouseFraction | null;
  onChange: (selected: HomepageOpenhouseFraction) => void;
}

const OpenHouseSelect: React.FC<OpenHouseSelectProps> = ({
  errors,
  cmsData,
  caseData,
  selected,
  label,
  onChange,
}) => {
  const style = cmsData.forms.style;
  const fontFamily = cmsData.theme.appearance
    ? "var(--body-font-family)"
    : isLookSystem(cmsData.theme)
      ? LOOK_FIELD_FONT
      : GetFont(cmsData.theme.fontType).style.fontFamily;
  const renderSelect = (variant: any) => (
    <FormControl
      size={style?.size}
      variant={variant}
      fullWidth
      className="col-span-6"
    >
      <InputLabel>{label}</InputLabel>
      <Select
        style={{ fontFamily: fontFamily }}
        required={true}
        error={!!errors}
        variant={variant}
        value={selected?.appointmentId}
        label={label}
        onChange={(e) => {
          onChange(
            caseData.openhouses.find(
              (x) => x.appointmentId === e.target.value,
            )!,
          );
        }}
      >
        {caseData.openhouses
          .filter((x) => x.bookingRequired)
          .map((openhouse, index) => (
            <MenuItem key={index} value={openhouse.appointmentId}>
              <span className="block truncate homepage-text-sm group-data-[selected]:font-semibold">{`${capitalize(getFormattedDateAndTime(new Date(openhouse.startDate!), new Date(openhouse.endDate!)))}`}</span>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );

  function getFormattedDateAndTime(startDate: Date, endDate: Date) {
    return `${formatDate(startDate, { weekday: "long", day: "numeric", month: "long" })} ${formatTime(startDate)} - ${formatTime(endDate)}`;
  }

  switch (style?.type) {
    case "material-outlined":
      return renderSelect("outlined");
    case "material-standard":
      return renderSelect("standard");
    default:
      return renderSelect("filled");
  }
};

export default OpenHouseSelect;
